import {Injectable} from '@angular/core';
import {ActionModel} from '../models/action.model';
import {ConfigurationService} from './configuration.service';
import {FindActionDetailsService} from './find-action-details.service';
import {CustomerModel} from '../models/customer.model';
import {ContactModel} from '../models/contact.model';
import {StateManagerService} from './state-manager.service';
import {RefreshdatabaseService} from './database/refreshdatabase.service';

@Injectable({
    providedIn: 'root'
})
export class NewActionService {

    constructor(private configService: ConfigurationService,
                private findActionDetails: FindActionDetailsService,
                private stateManager: StateManagerService,
                private refreshdatabaseService: RefreshdatabaseService) {
    }

    genNewAction(): ActionModel {
        const config = this.configService.getConfiguration();
        const action = new ActionModel();
        action.service_enquiry_id = null;
        action.actee_map_id = null;
        action.celko_lft = null;
        action.id = 0;
        action.celko_rgt = null;
        action.actor = config.selectedOperator;
        action.action_priority_id = 1;
        action.worker_id = null;
        action.date_completed = null;
        action.sigcap_queue_id = null;
        action.action_type_id_on_success = null;
        action.ws_job_id = null;
        action.action_type_id_on_failure = null;
        action.date_created = new Date().toISOString();
        action.created_by = config.selectedOperator;
        action.comment = ''; // Updated By Service;
        action.date_scheduled = new Date().toISOString();
        action.json_string = null;
        action.duration = 1;
        action.action_type_id = 3001;
        action.parent_action_id = null;
        action.date_started = null;
        action.seq = null;
        action.customerDTO = new CustomerModel();
        action.contactDTO = new ContactModel();

        return action;
    }

    async populateExtraFields(action: ActionModel) {
        action.actorName = this.findActionDetails.findOperatorName(action.actor);
        action.creatorName = this.findActionDetails.findOperatorName(action.created_by);
        action.priorityDesc = this.findActionDetails.findPriorityDescr(action.action_priority_id);
        action.typeDesc = this.findActionDetails.findActionTypeDesc(action.action_type_id);
        if (action.cust_id > 0) {
            const customers = this.stateManager.getCollection('customer'); // .chain().find({id: action.cust_id}).data()[0];
            action.customerDTO = customers.find(cust => {
                return cust.id === action.cust_id;
            });
        }
        if (action.actee_map_id > 0) {
            action.contactDTO = this.findContact(action);
            if (!action.contactDTO) {
                await this.refreshdatabaseService.refreshContactsResource();
                action.contactDTO = this.findContact(action);
            }
        }
    }

    private findContact(action: ActionModel): ContactModel {
        const contacts = this.stateManager.getCollection('contact'); // .chain().find({id: action.actee_map_id}).data()[0];
        return contacts.find(contact => {
            return contact.id === action.actee_map_id;
        });
    }
}
